// extracted by css-extract-rspack-plugin
export default {"cls1":"Comments-cls1_B4d","cls2":"Comments-cls2_8RO Comments-cls1_B4d"};